export const API_URL = process.env.REACT_APP_API_URL;

export const LOGIN_URL = "/auth/login";
export const REFRESH_TOKEN_URL = "/auth/refresh-token";
export const SEND_LOGIN_OTP = "/auth/send-login-otp";
export const VERIFY_MOBILE_OTP = "/auth/verify-login";
export const LOGOUT_URL = "/auth/logout";
export const LOGIN_FROM_MICROSOFT = "/auth/microsoft-login";
export const GET_GSTIN_DETAIL = "/entity/getGstDetails";
export const GET_PAN_DETAIL = "/entity/PanDetails";
export const SIGN_UP = "/entity/signUp";
export const VERIFY_OTP = "/auth/verify-otp";
export const RE_SEND_OTP = "/user/reSendOtp";
export const RESET_PASSWORD = "/auth/reset-password";
export const FORGET_PASSWORD = "/auth/forgot-password";
export const USER_CONSENT = "/user/update-user-consent";
export const CHECK_UDYAM_NUMBER = "/entity/check-udyam-number"
export const VALIDATE_USER = "/auth/validate-user";
//PERMISSION
export const ADD_PERMISSION = "/permissions/add-permission";
export const GET_PERMISSION = "/permissions/get-permissions-list";
export const EDIT_PERMISSION = "/permissions/update-permission";
export const GET_ONE_PERMISSION = "/permissions/get-permission";
export const GET_MODULES = "/permissions/get-module-list";

//EMAIL TEMPLATE
export const ADD_TEMPLATE = "/templatesEmail/add-email-template";
export const GET_TEMPLATE = "/templatesEmail/get-template-master-email-list";
export const EDIT_TEMPLATE = "/templatesEmail/update-email-template";
export const GET_EMAIL_TEMPLATE = "/templatesEmail/get-template-email";
export const GET_EMAIL_TEMPLATE_BY_TYPE = "/templatesEmail/get-template-email-by-type";
// SMS TEMPLATE
export const ADD_SMS_TEMPLATE = "/templatesSMS/add-sms-template";
export const GET_SMS_TEMPLATE_LIST =
  "/templatesSMS/get-template-master-sms-list";
export const EDIT_SMS_TEMPLATE = "/templatesSMS/update-sms-template";
export const GET_SMS_TEMPLATE = "/templatesSMS/get-template-sms";

// NOTIFICATION TEMPLATE
export const ADD_NOTIFICATION_TEMPLATE =
  "/templatesNotification/add-notification-template";
export const GET_NOTIFICATION_TEMPLATE_LIST =
  "/templatesNotification/get-template-master-notification-list";
export const EDIT_NOTIFICATION_TEMPLATE =
  "/templatesNotification/update-notification-template";
export const GET_NOTIFICATION_TEMPLATE =
  "/templatesNotification/get-template-notification";

//API CONFIGURATION
export const ADD_API_CONFIGURATION = "/apiConfiguration/add-apiconfig";
export const GET_API_CONFIGURATION = "/apiConfiguration/get-apiconfig-list";
export const EDIT_API_CONFIGURATION = "/apiConfiguration/update-apiconfig";
export const GET_ONE_API_CONFIGURATION = "/apiConfiguration/get-apiconfig";

//SYSTEM CONFIGURATION
export const ADD_SYSTEM_CONFIGURATION = "/systemConfiguration/add-systemconfig";
export const GET_SYSTEM_CONFIGURATION =
  "/systemConfiguration/get-systemconfig-list";
export const EDIT_SYSTEM_CONFIGURATION =
  "/systemConfiguration/update-systemconfig";
export const ONE_SYSTEM_CONFIGURATION =
  "/systemConfiguration/get-one-systemconfig";
export const UPLOAD_FILE = "/s3/uploadSystemConfigFiles";
export const DOWNLOAD_FILE = "/s3/downS3File";
export const GET_ONE_SYSTEM_CONFIGURATION =
  "/systemConfiguration/get-systemconfig";

//ROLE
export const ADD_ROLE = "/roles/add-role";
export const GET_ROLE = "/roles/get-roles-list";
export const GET_ROLE_ENTITYTYPE = "/roles/get-roles-by-entityType";
export const EDIT_ROLE = "/roles/update-role";
export const GET_ONE_ROLE = "/roles/get-role";

//ROLE PERMISSION
export const GET_ROLEPERMISSION =
  "/rolesPermissions/get-roles-permissions-list";
export const EDIT_ROLEPERMISSION = "/rolesPermissions/update-role-permissions";
export const GET_USER_DASHBOARD_WIDGET_PERMISSION =
  "/rolesPermissionsV1/get-user-dashboard-widget-permission-list";
export const GET_ROLEPERMISSION_LIST =
  "/rolesPermissionsV1/get-rolePermission-list";
export const EDIT_ROLEPERMISSION_LIST =
  "/rolesPermissionsV1/update-rolePermission";
export const GET_PERMISSION_FIELDS = "/rolesPermissionsV1/get-permission-list";
export const ADD_PERMISSION_LIST = "/rolesPermissionsV1/add-rolePermission";

//ADDRESS
export const GET_ADDRESS = "/address/get-address-list";
export const EDIT_ADDRESS = "/address/update-address";
export const DELETE_ADDRESS = "/address/delete-address";
export const ADD_ADDRESS = "/address/add-address";
export const GET_STATE = "/state/get-state-list";
export const GET_CITY = "/state/get-city-list";
export const GET_ADDRESS_BY_PERSONID = "/address/get-person-address";

//USER
export const ADD_USER = "/user/add-user";
export const EDIT_USER = "/user/update-user";
export const DELETE_USER = "/user/delete-user";
export const GET_USER = "/user/get-user";
export const GET_CI_USER = "/user/get-user-admin";
export const GET_USER_BY_ID = "/user/get-user-id-details";
export const GET_USER_BY_ENTITY_TYPE = "/user/get-user-by-entity-type";
export const GET_RM = "/user/get-user-rm";
export const CHANGE_USER_STATUS = "/user/change-user-status";

//ENTITY
export const GET_ENTITY = "/entity/get-entity-list";
export const CHECK_ENTITY_EXIST = "/entity/check-entity-exist";
export const UPDATE_ENTITY_STATUS = "/entity/update-entity-status";
export const GET_ONE_ENTITY = "/entity/get-one-entity";
export const GET_ENTITY_INFORMATION = "/entity/get-entity-add-information";
export const GET_OWNER_ID = "/entity/get-owner-id";
export const GET_CI_USERS = "/entity/get-ci-users";
export const GET_CI_USERS_ROLEWISE = "/entity/get-ci-users-rolewise"
export const EDIT_ENTITY = "/entity/update-entity";
export const PUSH_TO_TRADEASY_PAYEARLY = "/entity/push-to-payearly-tradeasy"
export const ADD_ENTITY = "/entity/add-entity";
export const ALL_ENTITY = "/entity/get-entity-all";
export const DELETE_ENTITY="/entity/delete-entity"
export const ANCHOR_ENTITY = "/entity/get-entity-anchor";
export const GET_CP_ANCHOR = "/entity/get-cp-anchor"
export const GET_ENTITY_ANCHOR_DEAL = "/entity/get-entity-anchor-deal";
export const GET_ENTITY_DETAIL = "/entity/entity-detail";
export const EXPORT_ENITTY_INFORMATION = "/entity/export-pdf";
export const ALL_FINANCIER = "/entity/get-entity-financier";
export const ADD_BORROWING = "/borrowing/add-borrowing";
export const GET_BORROWING = "/borrowing/get-borrowing-list";
export const EDIT_BORROWING = "/borrowing/update-borrowing";
export const ADD_AUTHORISEDPERSON = "/authorisedPerson/add-authorisedperson";
export const ADD_PROPRIETOR = "/authorisedPerson/add-proprietor";
export const GET_AUTHORISEDPERSON =
  "/authorisedPerson/get-authorisedperson-list";
  export const DELETE_AUTHORISEDPERSON =
  "/authorisedPerson/delete-authorisedperson";
export const EDIT_AUTHORISEDPERSON =
  "/authorisedPerson/update-authorisedperson";
export const EDIT_AUTHORISEDPERSON_STATUS =
  "/authorisedPerson/update-authorisedpersonStatus";
export const GET_CRIF = "/crif/get-crif-data";
// export const GET_CRIF_COMMERCIAL= "/crif/get-crif-commercial";
export const GET_CRIF_COMMERCIAL= "/crif/get-crif-commercial";
export const ADD_CRIF_REPORT= "/crif/add-crif-report";
export const GET_CRIF_REPORT= "/crif/get-crif-reports";
export const DELETE_CRIF_REPORT= "/crif/delete-crif-reports";
export const STAGE_QUESTION_PHASE= "/crif/get-crif-data-questionnaire";
export const REQ_CONSENT = "/entity/request-consent";
export const CHECK_ENTITY_DETAILS = "/entity/check-entity-detail";
export const GET_USER_CONSENT = "/entity/get_user_consent";

//TASK
export const ADD_TASK="/task/add-task";
export const GET_TASK = "/task/get-task";
export const GET_TASK_BY_DEAL_AND_STATUS = "/task/get-task-by-deal-and-status";
export const GET_TASK_BY_ID = "/task/get-task-by-id";
export const UPDATE_TASK = "/task/update-task";
export const UPDATE_TASK_STATUS = "/task/update-task-status";
export const SEND_REMINDER = "/task/send-notification";
export const GET_TASK_BY_ENTITY = "/task/get-task-by-entity";


// ENTITY/DEAL DEAL NOTES
export const GET_NOTES = "/entity/get-entity-deal-notes";
export const GET_NOTE_BY_ID = "/entity/get-note-by-id"
export const ADD_NOTES = "/entity/add-entity-deal-notes";
export const UPDATE_NOTES = "/entity/update-entity-deal-notes";
export const DELETE_NOTES = "/entity/delete-entity-deal-notes";
export const GET_NOTES_TABLE_DATA = "/entity/get-notes-table-data";

//ADD PARTNER
export const ADD_PARTNER = "/entity/add-partner";
export const EDIT_PARTNER = "/entity/update-partner";

//COMMERCIALS
export const GET_COMMERCIALS = "/entity/get-commercial-list";
export const GET_ONE_COMMERCIAL = "/entity/get-one-commercial";
export const ADD_COMMERCIAL = "/entity/add-commercial";
export const UPDATE_COMMERCIAL = "/entity/update-commercial";
export const GET_ENTITY_SCOREME_RESPONSE = "/entity/entity-response";

export const ADD_SHAREHOLDING = "/shareholding/add-shareholding";
export const GET_SHAREHOLDING = "/shareholding/get-shareholding-list";
export const EDIT_SHAREHOLDING = "/shareholding/update-shareholding";

//BUREAU
export const GET_AUTHORIZED_PERSON_ENTITY_LIST =
  "/authorisedPerson/get-authorisedperson-entity-list";
export const BUREAU_DOCUMENT_DELETE = "/scoreme/delete-BureauDocument";
export const BUREAU_DOCUMENT_LIST = "/scoreme/get-BureauDocument-list";

//DEAL
export const GET_DEAL = "/deal/get-deal-list";
export const GET_ENTITYWISE_DEAL = "/deal/get-entitywise-deal-list";
export const EDIT_DEAL = "/deal/update-deal";
export const ADD_DEAL = "/deal/add-deal";
export const ADD_DEAL_DRAFT = "/deal/add-deal-draft";
export const EDIT_DEAL_DRAFT = "/deal/update-deal-draft";
export const GET_DEALINFO = "/deal/get-deal-details";
export const GET_DEAL_FOR_TABS = "/deal/get-deal-list-tabs";
export const GET_DEAL_STATUS_COUNT = "/deal/deal-status-count";
export const GET_DEAL_LOGS = "/logs/get-logs";
export const Assign_DEAL_SELF = "/dealFinancier/update-deal-assignment-me";
export const Assign_DEAL_OTHERS = "/dealFinancier/update-deal-assignment";
export const DEAL_SHOW_INTEREST = "/dealFinancier/update-deal-show-interest";
export const FINANCIER_LIST = "dealFinancier/get-interested-financier";
export const DEAL_ESIGN = "deal/update-deal-e-sign";
export const DEAL_MOU_SIGN = "deal/update-deal-mou";
export const GET_TEMPLATE_VALUES = "/digio/getTemplateValue";
export const DIGIO_SIGN_REQUEST = "/digio/signRequest";
export const DIGIO_MANUAL_SIGN_REQUEST = "/digio/signManually";
export const DIGIO_MANUAL_SIGN_REQUEST_MOU = "/digio/signManually-MoU";
export const SAVE_DIGIO_RESPONSE = "/digio/save-digio-response";
export const DOWNLOAD_DEAL_PDF = "/deal/download-pdf";
export const GET_DOCUMENTS = "deal/get-doc";
export const GET_ONE_DEAL = "deal/get-deal-by-id";
export const ADD_MANDATE = "/deal/add-mandate";
export const DOWNLOAD_CAM_PROFILE = "/deal/cam-download";
export const DOWNLOAD_CAM_PROFILE_WORD = "/deal/cam-download-word";
export const GET_MANDATE = "/deal/get-mandate"
export const DOWNLOAD_MANDATE = "/deal/downlaod-mandate"
export const ADD_DEAL_STATUS = "/deal/add_deal_status";
export const ADD_MOU = "/deal/add-mou_template";
export const GET_MOU = "/deal/get-mou";
export const DIGIO_SIGN_REQUEST_MOU = "/digio/sign-mou-request";
export const SAVE_DIGIO_RESPONSE_MOU = "/digio/save-digio-response-mou";
export const DEAL_SUMMARY = "/deal/get-deal-summary";
export const DEAL_FINANCIER_DETAILS = "/deal/get-deal-financier-details";
export const ADD_DEAL_TERMSHEET= "/deal/add-deal-termsheet";
export const DELETE_DEAL="/deal/delete-deal"

//DROPDOWN
export const GET_DROPDOWN = "/dropdown/get-dropdown-values";
export const GET_DROPDOWNNAMES = "/dropdown/get-dropdown-keys";
export const GET_DROPDOWN_STATES = "/state/get-state-list";

//NOTIFICATION
export const GET_ALL_NOTIFICATION = "/notification/get-all-notifications";
export const GET_READ_NOTIFICATION = "/notification/get-read-notifications";
export const GET_UNREAD_NOTIFICATION = "/notification/get-unread-notifications";
export const UPDATE_MARK_READ = "/notification/update-markasread";
export const UPDATE_MARKALL_READ = "/notification/update-markallasread";

//ITR
export const ITR_USRENAME_PASSWORD = "/scoreme/itr-file-automate-request";
export const ITR_FILE_UPLOAD = "/scoreme/itr-pdf-file-request";
export const ITR_XML_UPLOAD = "/scoreme/itr-xml-file-request";
export const ITR_DOCUMENT_LIST = "/scoreme/get-ItrDocument-list";
export const ITR_DOCUMENT_DELETE = "/scoreme/delete-ItrDocument";

// additional Documents
export const ADD_ADDITIONAL_DOCUMENTs = "/scoreme/saveAdditionalDocuments";
export const GET_ADDITIONAL_DOCUMENTs = "/scoreme/get-additionalDocuments";
export const DELETE_DOCUMENTS = "/entity/deleteDocuments";

//GST
export const GST_USRENAME_PASSWORD = "/scoreme/pwd-gstanalysisrequest";
export const GST_USRENAME_OTP = "/scoreme/gstgenerateotp";
export const GST_USRENAME_OTP_VALID = "/scoreme/gstValidateOTP";
export const GST_DOCUMENT_LIST = "/scoreme/get-GstDocument-list";
export const GST_DOCUMENT_DELETE = "/scoreme/delete-GstDocument";

//BANK STATEMENT
export const BANK_STATEMENT_UPLOAD = "/scoreme/upload-bank-statement";
export const BANK_STATEMENT_DOCUMENT_LIST = "/scoreme/get-BSA-list";
export const BANK_STATEMENT_DOCUMENT_DELETE = "/scoreme/delete-BsaDocument";
export const BANK_STATEMENT_MERGE = "/scoreme/bsa-merge";

// CREDIT RATING 
export const ADD_CREDIT_RATING = "/creditRating/add-credit-rating";
export const GET_CREDIT_RATING = "/creditRating/get-credit-rating";
export const EDIT_CREDIT_RATING = "/creditRating/edit-credit-rating";
export const DELETE_CREDIT_RATING = "/creditRating/delete-credit-rating";

// INSURANCE_DETAILS
export const ADD_INSURANCE_DETAILS = "/insuranceDetails/add-insurance-details";
export const GET_INSURANCE_DETAILS = "/insuranceDetails/get-insurance-details";
export const EDIT_INSURANCE_DETAILS = "/insuranceDetails/edit-insurance-details";
export const DELETE_INSURANCE_DETAILS = "/insuranceDetails/delete-insurance-details";

// INSURANCE_DETAILS
export const ADD_LISTING_PREFERENCE = "/listingPreference/add-listing-preference";
export const GET_LISTING_PREFERENCE = "/listingPreference/get-listing-preference";
export const EDIT_LISTING_PREFERENCE = "/listingPreference/edit-listing-preference";
export const DELETE_LISTING_PREFERENCE = "/listingPreference/delete-listing-preference";

//BANK LIST
export const BANK_LIST = "/bank/get-bank-list";
export const ADD_BANK_DETAILS = "/bankDetails/add-bank-details";
export const GET_BANK_DETAILS = "/bankDetails/get-bank-details";
export const EDIT_BANK_DETAILS = "/bankDetails/edit-bank-details"


export const ADD_CAM_DATA = "/camdata/add-cam-data";
export const GET_CAM_DATA = "/camdata/get-cam-data";
export const EDIT_CAM_DATA = "/camdata/edit-cam-data";
export const APPROVE_CAM = "/camdata/approve-cam";
export const DOWNLOAD_CAM = "/camdata/download-cam";

// point of contact 
export const ADD_POC_DETAILS = "/pointOfContact/add-poc-details";
export const GET_POC_DETAILS = "/pointOfContact/get-poc-details";
export const EDIT_POC_DETAILS = "/pointOfContact/edit-poc-details";
export const DELETE_POC_DETAILS = "/pointOfContact/delete-poc-details";
export const SET_PRIMARY_POC = "/pointOfContact/set-primary";
export const GET_PRIMARY_POC = "/pointOfContact/get-primary";
export const GET_ANCHOR_POC_DETAILS = "/pointOfContact/get-anchor-poc-details";
export const DELETE_ANCHOR_POC_DETAILS = "/pointOfContact/delete-anchor-poc-details";
export const ADD_ANCHOR_POC_DETAILS = "/pointOfContact/add-anchor-poc-details";
export const ADD_COUNTERPARTY_POC_DETAILS = "/pointOfContact/add-counterparty-poc-details";
export const GET_COUNTERPARTY_DETAILS = "/pointOfContact/get-counterparties";

// ALL ACHORS FROM ENTITY
export const ANCHOR_LIST = "/entity/get-anchor-entity";

//Finncier List
export const FINANCIER_TYPE_LIST = "/entity/get-financier-list";
export const FINANCIER_TYPE_LIST_SUMMARY = "/entity/get-financier-list-summary";
export const GET_REFERRED_FINANCIER = "/financierPrefrence/get-financier-list";

//Financial
export const FINANCIAL_CIN = "/mca/mcaCompany";
export const FINANCIAL_OTP = "/scoreme/upload-financial-statement";
export const FINANCIAL_DOCUMENT_LIST = "/scoreme/get-FinancialDocument-list";
export const FINANCIAL_DOCUMENT_DELETE = "/scoreme/delete-FinancialDocument";

//Base Api probe
export const PROBE_BASE_API = "/mca/probe-base-api";
export const GET_PROBE_BASIC_DETAILS = "/mca/get-basic-details";
export const GET_PROBE_CREDIT_RATINGS = "/mca/get-probe-credit-ratings";
export const GET_FINANCIAL_SUMMARY = "/mca/get-financials-summary";
export const UPDATE_FINANCIAL_SUMMARY = "/mca/update-financials-summary";
//COMMERCIAL
export const GET_COMMERCIAL_PAN = "/entity/get-one-commercial-pan";

//CIN
export const GET_CIN_DETAIL = "/entity/CinDetails";

export const PUSH_TO_TRADEASY = "/entity/push-to-tradeasy";
export const PUSH_TO_PAYEARLY = "/entity/push-to-payearly";

//DEAL FINANCIER
export const GET_DEALFINACIER = "/dealFinancier/get-deal-financier";
export const UPDATE_DEALFINACIER_STATUS = "/dealFinancier/update-deal-financier-status";

export const GET_DEALFINACIER_OPERATION =
  "/dealFinancier/get-deal-financier-operations";
export const UPDATE_DEALFINACIER = "/dealFinancier/update-deal-financier";
export const UPDATE_DEALFINACIER_LEAD =
  "/dealFinancier/update-deal-financier-lead";
export const GET_DEAL_FIN_INFO = "/dealFinancier/get-one-deal_financier";
export const  FINANCIER_REFERRED  = '/dealFinancier/get-referred-financier'
export const  FINANCIER_ACCEPTED = '/dealFinancier/get-accepted-financier'
export const FINANCIER_REJECTED = '/dealFinancier/get-rejected-financier'

//USER DASHBBOARD WIDGET
export const GET_USER_DASHBOARD_WIDGET =
  "/userDashboardWidget/get-dashboard-widget-details";
export const ADD_USER_DASHBOARD_WIDGET =
  "/userDashboardWidget/add-dashboard-widget";
export const EDIT_USER_DASHBOARD_WIDGET =
  "/userDashboardWidget/update-dashboard-widget";
export const GET_ADMIN_STATS = "/userDashboardWidget/get-admin-stats";
export const GET_ADMIN_STATS_PART_ONE = "/userDashboardWidget/get-admin-stats-part-one";
export const GET_ADMIN_STATS_PART_TWO = "/userDashboardWidget/get-admin-stats-part-two";
export const GET_DEALSTATUS = "/deal/deal-status";
export const GET_TOPFIN = "/dashboard/get-top-financier";
export const GET_DEALCREATED = "/dashboard/get-monthwise-deal-created";
export const GET_TOPCUSTOMER = "/dashboard/get-top-customer";
export const GET_ENTITY_BY_OWNERS = "/dashboard/get-entity-by-owners";
export const GET_ENTITY_YEARS = "/dashboard/get-entity-years";
export const GET_ENTITY_BY_PDT_AND_SERVICES = "/dashboard/get-entity-by-pdt-and-services";
export const GET_PENDING_TASKS = "/dashboard/get-pending-tasks";
export const GET_OVERDUE_TASKS = "/dashboard/get-overdue-tasks";
export const GET_CUSTOMER_ONBOARDED = "/dashboard/get-noOf-customer-onboarded";
export const GET_MONTHWISE_INTEREST = "/dashboard/get-monthwise-interest-shown";
export const GET_MONTHWISE_DEAL_FINANCIER = "/dashboard/get-monthwise-deal_for_fi";
export const GET_DEAL_STATUS_FI = "/dashboard/get-total-deals-FI-user";
export const GET_MONTHWISE_INTEREST_FOR_FIN_USER ="/dashboard/get-monthwise-interest-shown-for-user";
export const GET_FINASSIGNED = "/dashboard/get-deal-assigned-to-FI-users";
export const GET_FINSTATS = "/dashboard/get-financier-stats";
export const GET_DEALSASSIGNEDTO_CIUSERS =
  "/dashboard/get-deal-assigned-to-CI-users";
//DealFinancier
export const ADD_WORKFLOW = "/workflow/add-workflow";
export const GET_WORKFLOW = "/workflow/get-workflow-list";
export const GET_WORKFLOW_BY_ID = "/workflow/get-one-workflow";
export const UPDATE_WORKFLOW = "/workflow/update-workflow";
export const DELETE_WORKFLOW = "/workflow/delete-workflow";

//QUERY
export const GET_QUERY = "/query/get-query-list";
export const GET_QUERY_ENTITY = "/query/get-query-list-entity";
export const ADD_QUERY = "/query/add-query";
export const UPDATE_QUERY = "/query/update-query";
export const DELETE_QUERY = "/query/deletequery";
export const GET_FILE = "/query/get-file-list";
export const GET_QUERY_CUSTOMERS = "/query/get-query-list-customers";

//SCOREME
export const GET_ONE_SCOREME_RESPONSE = "/scoreme/findOneScoremeResponse";

//INDUSTRY LIST
export const INDUSTRY_LIST = "/industry/get";

//FINANCIER PREFERENCE
export const ADD_FINANCIER_PREFERENCE = "/financierPrefrence/create";
export const LIST_FINANCIER_PREFERENCE = "/financierPrefrence/get";
export const UPDATE_FINANCIER_PREFERENCE = "/financierPrefrence/update";
export const DELETE_FINANCIER_PREFERENCE = "/financierPrefrence/delete";
export const GET_FINANCIER_PREFERENCE = "/financierPrefrence/get-financier";

export const ADD_PARTNER_ENQUIRY = "/enquiry/add-enquiry";

//MEETINGS
export const SCHEDULE_MEETING="/meeting/schedule-meeting";
export const GET_ALL_MEETINGS = "/meeting/get-all-meeting";
export const GET_MEETINGS_BY_ID = "/meeting/get-meeting-by-id";
export const GET_MEETINGS_BY_DEAL_AND_STATUS = "/meeting/get-meeting-by-deal-and-status";
export const GET_MEETINGS_BY_ENTITY = "/meeting/get-meetings";
export const UPDATE_MEETINGS = "/meeting/update-meeting";
export const UPDATE_MEETINGS_STATUS = "/meeting/update-meeting-status";
export const ADD_EVENT = "/meeting/add-event";
export const UPLOAD_BULK_ENTITY = "/entity/upload_bulk_entity";
export const GET_FILE_BY_BATCH = "/entity/get-file-upload-by-batch";
export const GET_FILE_COUNT = "/entity/get-file-upload-count";

export const GET_FILE_BY_ID = "/entity/bulk-file-id"
export const GET_ALL_FILE_DATA = '/entity/get-data-by-batch'
export const GET_FILE_BY_FILEID = "/entity/bulk-file-data-by-file-id"
export const CREATE_BULK_ENTITY = "/entity/create-bulk-entities"
